import React from 'react';

import {Card, CardContent, CardHeader, Stack, TextField} from '@mui/material';

import {Types} from '@wheeebo/polaris-api';
import {MemberPanel} from '@wheeebo/polaris-ui';

interface Props {
  memberId: Types.UUID;
}

const MemberProfileCard = ({memberId}: Props): JSX.Element => {
  return (
    <Card variant="outlined">
      <CardHeader title="Member Profile" />
      <CardContent>
        <Stack gap={1}>
          <MemberPanel memberId={memberId} />
          <TextField disabled fullWidth variant="standard" label="Member ID" value={memberId} />
        </Stack>
      </CardContent>
    </Card>
  );
};

export default React.memo(MemberProfileCard);
